import { VxeRadioButton } from 'vxe-pc-ui';
import defPropMixin from './defPropMixin';
export default {
  name: 'XRadioButton',
  components: {
    VxeRadioButton
  },
  mixins: [defPropMixin],
  props: {
    title: {
      type: [String, Number],
      default: ''
    },
    value: {
      type: [String, Number]
    },
    label: {
      type: [String, Number]
    },
    strict: {
      type: Boolean,
      default: true
    }
  },
  emits: ['change', 'update:value'],
  setup(props, {
    emit
  }) {
    const handleChanged = ({
      value,
      label,
      $event
    }) => {
      emit('change', {
        value,
        label,
        $event
      });
      emit('update:value', value, $event);
    };
    return {
      handleChanged
    };
  }
};